"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FalconCheckboxWidget = void 0;
var React = require("react");
var journey_model_1 = require("@athena-portal/journey-model");
var journey_services_1 = require("@athena-portal/journey-services");
var FalconQuestionWidgetBase_1 = require("./FalconQuestionWidgetBase");
var react_html_parser_1 = require("react-html-parser");
var FalconCheckboxWidget = exports.FalconCheckboxWidget = /** @class */ (function (_super) {
    __extends(FalconCheckboxWidget, _super);
    function FalconCheckboxWidget(props) {
        var _this = _super.call(this, props) || this;
        var checkboxLabel = _this.getSetting("checkboxLabel", undefined);
        if (!checkboxLabel) {
            throw Error("".concat(_this.props.question.type, " widget missing 'checkboxLabel' setting"));
        }
        else {
            _this.checkboxLabel = checkboxLabel;
        }
        _this.handleOnClickEvent = _this.handleOnClickEvent.bind(_this);
        _this.handleOnChange = _this.handleOnChange.bind(_this);
        return _this;
    }
    FalconCheckboxWidget.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "falcon-checkbox form-group ".concat(this.getSetting("cssClass", "")) },
                this.props.question.label && React.createElement("label", { className: "fs-18", tabIndex: 0 }, this.props.question.label),
                React.createElement("div", { className: "d-flex" },
                    React.createElement("div", { className: "form-check mr-3", onClick: this.handleOnClickEvent },
                        this.renderInputField(),
                        React.createElement("label", { className: "custom-control-label", htmlFor: this.props.question.name },
                            React.createElement("div", { className: "checkbox-big" }),
                            React.createElement("div", { className: "checkbox-label ".concat(this.getSetting("checkboxLabelCssClass", "")) }, (0, react_html_parser_1.default)(this.renderTemplate(this.checkboxLabel, true), { transform: function (node) {
                                    if (node.name === 'script' || node.name === 'style' || node.name === 'link') {
                                        return null;
                                    }
                                    return;
                                } }))),
                        this.getSetting("additionalLabel") &&
                            (0, react_html_parser_1.default)(this.renderTemplate(this.getSetting("additionalLabel"), true), { transform: function (node) {
                                    if (node.name === 'script' || node.name === 'style' || node.name === 'link') {
                                        return null;
                                    }
                                    return;
                                } }))),
                this.getSetting("helpText") &&
                    React.createElement("small", { id: this.props.question.name + "HelpBlock", className: "form-text text-muted" }, this.getSetting("helpText")),
                this.renderValidationResult(),
                this.getSetting("validFeedback") && this.isValid() && React.createElement("div", { className: "valid-feedback d-block" }, this.getSetting("validFeedback")))));
    };
    FalconCheckboxWidget.prototype.renderInputField = function () {
        return (React.createElement("input", { className: "custom-control-input ".concat(this.isChecked()), type: "checkbox", "aria-label": this.getSetting("ariaLabel", ""), onChange: this.handleOnChange, onFocus: this.executeNativeEvent, onBlur: this.handleOnBlurEvent, onDoubleClick: this.executeNativeEvent, name: this.props.question.name, id: this.props.question.name, checked: this.isChecked() }));
    };
    FalconCheckboxWidget.prototype.handleOnChange = function (e) {
        e.preventDefault();
    };
    FalconCheckboxWidget.prototype.handleOnClickEvent = function (e) {
        e.preventDefault();
        var checked = !this.isChecked();
        journey_services_1.ObjectManipulator.setField(this.props.question.interactionField, this.props.interaction, checked.toString());
        this.validateInternal(checked);
        this.changelogRecorder.recordQuestion("change", this.props);
        this.executeNativeEvent(e);
    };
    FalconCheckboxWidget.prototype.isChecked = function () {
        var value = this.bindFromField(this.props.question.interactionField);
        if (!value) {
            // Workaround for FAL-37427
            // If original field value was null, after bindFromField it gets set to undefined (which has the same meaning as null
            // or false in this widget), but undefined value raises problems on some iOS devices.
            journey_services_1.ObjectManipulator.setField(this.props.question.interactionField, this.props.interaction, "false");
        }
        return value === true || value === "true" || false;
    };
    FalconCheckboxWidget = __decorate([
        (0, journey_model_1.event)(journey_model_1.Event.onClick),
        (0, journey_model_1.settings)([
            { name: "ariaLabel", type: journey_model_1.TypeDescriptions.String },
            { name: "checkboxLabel", type: journey_model_1.TypeDescriptions.String },
            { name: "additionalLabel", type: journey_model_1.TypeDescriptions.String }
        ]),
        __metadata("design:paramtypes", [Object])
    ], FalconCheckboxWidget);
    return FalconCheckboxWidget;
}(FalconQuestionWidgetBase_1.FalconQuestionWidgetBase));
//# sourceMappingURL=FalconCheckboxWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/FalconCheckboxWidget.js
// module id = 3637
// module chunks = 0